import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-analogue',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Analogue icon</title><path d="M5.468 12.804a5.145 5.145 0 10-.644 10.27 5.145 5.145 0 00.644-10.27zm17.841 2.562L16.45 3.484a5.146 5.146 0 00-8.912 5.15l6.86 11.878a5.148 5.148 0 007.031 1.885 5.146 5.146 0 001.881-7.031z"/></svg>`,
    styles: []
})
export class SimpleIconsAnalogueComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#1A1A1A';
    @Input() className: string = 'simple-icons-analogue'
    constructor() {}
    ngOnInit(): void {}
}
